<template>
  <el-container id="glAreaGrp">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>
        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container style="display: flex">
      <el-main style="background:#FFFFFF;padding:15px;width:70%">
        <div style="display:flex;height:36px;width:100%;line-height:0.3;text-align:left;align-items: center;">
          <!--          <span style="margin-left:0; color: #ffffff; font-size: 13px">-->
          <!--            <el-input-->
          <!--              placeholder="输入名称查询"-->
          <!--              style="width:10vw;"-->
          <!--              prefix-icon="el-icon-search"-->
          <!--              clearable-->
          <!--              @change="getGrpList()"-->
          <!--              v-model="scan_name">-->
          <!--            </el-input>-->
          <!--          </span>-->
          <el-button @click="addGrp" size="small" type="primary"
                     style="margin-left:auto;margin-right:0px">
            新增分组
          </el-button>
        </div>
        <el-table :data=tabData class="tab_adb" :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px"
                  :max-height=maxHeight show-overflow-tooltip
                  :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
          <el-table-column width="01" sortable/>
          <div v-for="(d,item) in this.defHead">
            <el-table-column :key=item :prop=d.val :label=d.key :width="d.w" sortable>
            </el-table-column>
          </div>
          <el-table-column
              label="更新空间"
              width="200">
            <template slot-scope="scope">
              <el-button @click="upRooms(scope.row)" type="text" size="small"
                         style="color:#5AA3FF;font-size: 14px">更新空间
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              width="200">
            <template slot-scope="scope">
              <el-button @click="changeGrp(scope.row)" type="text" size="small" icon="el-icon-edit"
                         style="color:#72767b;font-size: 16px"/>
              <el-button @click="delGrp(scope.row)" type="text" size="small" icon="el-icon-delete"
                         style="color:#72767b;font-size: 16px"/>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="float:right; margin-right:0.5vw;margin-top:5px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10,20,30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </el-main>
      <div style="width:30%;margin-left:6px;background:#FFFFFF;padding-left:15px;padding-right:15px">
        <div style="height:50px;width:100%;display:flex;align-items:center">
          <p style="font-size: 20px;font-weight:bold">{{ grp_show }}</p>
          <el-button @click="onAddRoom" type="primary" size="small" style="margin-left: auto;">新增空间</el-button>
        </div>
        <el-table :data=tabRoom :cell-style="tableYs"
                  style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px"
                  :max-height=maxHeight show-overflow-tooltip
                  :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
          <el-table-column width="01" sortable/>
          <div v-for="(d,item) in this.liRoomHead">
            <el-table-column :key=item :prop=d.val :label=d.key :width="d.w" sortable>
            </el-table-column>
          </div>
          <el-table-column
              label="操作"
              width="200">
            <template slot-scope="scope">
              <el-button @click="delRoom(scope.row)" type="text" size="small" icon="el-icon-delete"
                         style="color:#72767b;font-size: 16px"/>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-container>
    <el-dialog title='新增分组' center :close-on-click-modal="false"
               width="300px" class="dialogApp"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiGrp'> <!--v-draggable 拖动-->
      <div style="display:flex;margin-top:6px">
        <span style="margin-left:0px;color: #000000; font-size: 13px">
          分组名称：
          <el-input v-model="edi_name"
                    style="margin-left:13px; width:160px;color: #000000; font-size: 15px"></el-input>
        </span>
      </div>
      <div style="display:flex;width:100%;margin-top:20px">
        <el-button type="primary" @click="daiGrp=false" style="margin-left:auto;margin-right:5px">取消</el-button>
        <el-button type="primary" @click="KeepAddGrp" style="margin-left:10px;margin-right:0">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title='添加空间' center :close-on-click-modal="false"
               width="500px" height="600px" class="dialog_daiAddDev"
               style="-moz-user-select: none;user-select: none; font-size: inherit;"
               :visible.sync='daiAddRoom'> <!--v-draggable 拖动-->
      <div style="display:flex;height:50px;width:100%;line-height:0.3;text-align:left;align-items: center;">
        <el-input v-model="scan_nameSon" prefix-icon="el-icon-search" placeholder="请输入房间名称"
                  style="width:50%;margin-left:0" clearable></el-input>
      </div>
      <div style="margin-top:1px;">
        <el-table :data=fil_sonTabData class="myTable_db" :cell-style="tableYs" border
                  style="width:100%; font-size:14px; background:#ffffff;"
                  height="40vh" show-overflow-tooltip :row-key="rowKey"
                  @selection-change="handleCurrentChange1" ref="multipleTable"
                  :header-cell-style="{'text-align':'left','background':'#F4F4F4','color':'#000000'}">
          <el-table-column
              type="selection"
              :reserve-selection="true"
              :selectable="selectable"
              width="60">
          </el-table-column>
          <el-table-column v-for="(d,item) in this.liDevHead" :key=item
                           :prop=d.val :label=d.key>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top:10px;display:flex;height:50px;width:100%;line-height:0.3;
                  text-align:left;align-items:center;">
        <el-button @click="daiAddRoom=false" style="margin-left: auto">取消</el-button>
        <el-button @click="keepRoomS()" type="primary">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="删除提示"
        :visible.sync="daiDelGrp"
        width="30%">
      <span>确定删除该分组吗？ 删除后将无法找回，请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDelGrp = false">取 消</el-button>
        <el-button type="primary" @click=KeepDelGrp>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="移除提示"
        :visible.sync="daiDelRom"
        width="30%">
      <span>确定移除该空间吗？ 请谨慎操作</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="daiDelRom = false">取 消</el-button>
        <el-button type="primary" @click=KeepDelRoom>确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  name:"glAreaGrp",
  data() {
    return {
      h_text:"区域分组",
      li_h_text:[
        {"text":"区域管理","colour":"#B7B7B7","pages":""}
      ],
      li_roomId:[],
      li_roomName:[],
      edi_name:"",
      room_id:0,
      grp_id:0,
      opt_gtp:"add",
      daiGrp:false,
      daiAddRoom:false,
      xz_tab:0,
      grp_show:"空间管理",
      edi_auth:[],
      li_room:[], /*角色列表*/
      li_grp:[],
      scan_name:"",
      scan_nameSon:"",
      page:1,
      pageSize:10,
      total:0,
      roomPage:1,
      roomPageSize:10,
      roomTotal:10,
      maxHeight:window.innerHeight - 225,
      li_dev_xz:[],
      liDevHead:[
        {'key':"房间名称",'val':"label","w":"auto"}
      ],
      tabRoom:[],
      liRoomHead:[
        {'key':"房间名称",'val':"label","w":"auto"}
      ],
      tableData:[],
      defHead:[
        {'key':"分组名称",'val':"name","w":"auto"},
        {'key':"空间",'val':"roomNameS","w":"auto"}
      ],
      tabData:[],
      edi_status:"",
      li_status:[
        {
          value:'1',
          label:'启用'
        },
        {
          value:'0',
          label:'禁用'
        }
      ],
      edi_wx:"",
      li_wx:[
        {
          value:'是',
          label:'是'
        },
        {
          value:'否',
          label:'否'
        }
      ],
      post_head:{},
      daiDelGrp:false,
      daiDelRom:false
    };
  },
  methods:{ /*方法存放*/
    rowKey(row) {
      return row.id;
    },
    selectable(row,index) { /*表格勾选框判断*/
      let is_show = true;
      return is_show;
    },
    handleCurrentChange1(val) {
      this.currentRow = val;
    },
    keepRoomS() {
      const params = {
        'id':this.grp_id,
        'projectId':localStorage.getItem("projectId")
      };
      let rooms = [];
      for (let i = 0; i < this.currentRow.length; i++) {
        rooms.push({  // label\value
          "id":this.currentRow[i]['value'],
          'projectId':localStorage.getItem("projectId")
        });
      }
      params["rooms"] = rooms;
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.appendRoom2Union,params,headers).then(res => {
        console.log(res.data.data);
        this.daiGrp = false;
        if (this.opt_gtp === "add") {
          this.$message.success("添加成功");
        } else {
          this.$message.success("修改成功");
        }
        this.getGrpS();
      }).catch(error => {
        this.daiGrp = false;
        console.log(error);
        if (error) {
          this.$message.error("操作失败");
        }
      });
      this.daiAddRoom = false;
    },
    onAddRoom() {
      if (this.grp_id === 0) {
        this.$message.info("请先添加分组");
      } else {
        this.li_room = [];
        this.getRoomS();
      }
    },
    changeGrp(row) {
      this.grp_id = row.id;
      this.opt_gtp = "change";
      this.edi_name = row.name;
      this.daiGrp = true;
    },
    addGrp() {
      this.opt_gtp = "add";
      this.edi_name = "";
      this.daiGrp = true;
    },
    upRooms(row) {
      this.grp_id = row.id;
      this.grp_show = row.name;
      this.li_roomId = row.li_roomId;
      this.li_roomName = row.li_roomName;
      let l = [];
      for (let i = 0; i < row.li_roomId.length; i++) {
        l.push({
          label:row.li_roomName[i],value:row.li_roomId[i]
        });
      }
      this.tabRoom = l;
    },
    KeepAddGrp() {
      let url1 = "";
      const params = {
        'name':this.edi_name,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.opt_gtp === "add") {
        url1 = this.$urls.addRoomUnion;
      } else {
        params["id"] = this.grp_id;
        url1 = this.$urls.updateRoomUnion;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + url1,params,headers).then(res => {
        console.log(res.data.data);
        this.daiGrp = false;
        if (this.opt_gtp === "add") {
          this.$message.success("添加成功");
        } else {
          this.$message.success("修改成功");
        }
        this.getGrpList();
      }).catch(error => {
        this.daiGrp = false;
        console.log(error);
        if (error) {
          this.$message.error("操作失败");
        }
      });
    },
    changeUser(row) {
      const params = {
        'id':row.id,
        'UserName':row.userName,
        'projectId':localStorage.getItem("projectId")
      };
      if (row.userState) {
        params['userStateId'] = 3;
      } else {
        params['userStateId'] = 5;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.setSysUserInfo,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    delRoom(row) {
      this.room_id = row.value;
      this.daiDelRom = true;
    },
    delGrp(row) {
      this.grp_id = row.id;
      this.daiDelGrp = true;
    },
    KeepDelGrp() {
      const params = {
        'id':this.grp_id,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delRoomUnion,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("删除成功");
        this.daiDelGrp = false;
        if (this.total % this.pageSize === 1 && this.page !== 1) {
          this.page -= 1;
        }
        this.getGrpList();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("删除失败");
        }
      });
    },
    KeepDelRoom() {
      const params = {
        'id':this.grp_id,
        'rooms':[{"id":this.room_id,'projectId':localStorage.getItem("projectId")}],
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.delRoomFromUnion,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("删除成功");
        this.daiDelRom = false;
        this.getGrpS();
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("删除失败");
        }
      });
    },
    getGrpS() { /*获取分组空间状态*/
      const params = {
        'id':this.grp_id,
        'rooms':[{"id":this.room_id,'projectId':localStorage.getItem("projectId")}],
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getRoomUnion,params,headers).then(res => {
        console.log("分组信息",res.data.data);
        this.initGrp(res.data.data);
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取失败");
        }
      });
    },
    initGrp(data) {
      let d = {
        id:data['id'],
        name:data['name'],
        li_roomId:[],
        li_roomName:[],
        roomNameS:""
      };
      for (let j = 0; j < data['rooms'].length; j++) {
        d["li_roomId"].push(data['rooms'][j]["id"]);
        d["li_roomName"].push(data['rooms'][j]["name"]);
      }
      d["roomNameS"] = d["li_roomName"].join(',');
      this.grp_id = d.id;
      this.grp_show = d.name;
      this.li_roomId = d.li_roomId;
      this.li_roomName = d.li_roomName;
      let l = [];
      for (let i = 0; i < d.li_roomId.length; i++) {
        l.push({
          label:d.li_roomName[i],value:d.li_roomId[i]
        });
      }
      this.tabRoom = l;
      let index2 = this.tabData.findIndex((fruit) => { /*弹窗状态改变*/
        return fruit['id'] === d.id;
      });
      if (index2 !== -1) {
        this.tabData[index2] = d;
        this.tabData = [...this.tabData];
      }
      console.log("index2",this.tabData);
    },
    tableYs({row,column,rowIndex,columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282';
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getGrpList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getGrpList();
    },
    show_change1(item) {
      if (item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item) {
      if (item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item) {
      if (item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    init_View() {
      let data = this.li_grp;
      let li_d = [];
      for (let i = 0; i < data.length; i++) {
        let d = {
          id:data[i]['id'],
          name:data[i]['name'],
          li_roomId:[],
          li_roomName:[],
          roomNameS:""
        };
        for (let j = 0; j < data[i]['rooms'].length; j++) {
          d["li_roomId"].push(data[i]['rooms'][j]["id"]);
          d["li_roomName"].push(data[i]['rooms'][j]["name"]);
        }
        d["roomNameS"] = d["li_roomName"].join(',');
        li_d.push(d);
      }
      this.grp_id = li_d[0].id;
      this.grp_show = li_d[0].name;
      this.li_roomId = li_d[0].li_roomId;
      this.li_roomName = li_d[0].li_roomName;
      let l = [];
      for (let i = 0; i < li_d[0].li_roomId.length; i++) {
        l.push({
          label:li_d[0].li_roomName[i],value:li_d[0].li_roomId[i]
        });
      }
      this.tabRoom = l;
      console.log(this.tabData);
      this.tabData = li_d;
    },
    getRoomS() {
      const params = {
        'page':this.roomPage,
        'pageSize':this.roomPageSize,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getRoomList,params,headers).then(res => {
        console.log("getRoomList",res.data.data);
        this.roomTotal = res.data.data["total"];
        let data = res.data.data.list;
        let l = this.li_room;
        for (let i = 0; i < data.length; i++) {
          let d = {
            value:data[i]['id'],
            label:data[i]['name']
          };
          if (!this.li_roomId.includes(data[i]['id'])) {
            l.push(d);
          }
        }
        this.li_room = l;
        if (this.roomPage * this.roomPageSize < this.roomTotal) {
          this.roomPage += 1;
          this.getRoomS();
        } else {
          this.daiAddRoom = true;
          console.log("----getRoomList-----",this.li_room);
          setTimeout(() => {
            this.$refs.multipleTable.clearSelection(); /*清空选中*/
            // this.selectAllRows();
          },100);
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取房间列表失败");
        }
      });
    },
    selectAllRows() { /*设置表格初始默认选中*/
      this.fil_sonTabData.forEach(row => {
        if (this.li_roomId.includes(row.value)) {
          this.$refs.multipleTable.toggleRowSelection(row,true);
        } else {
          this.$refs.multipleTable.toggleRowSelection(row,false);
        }
      });
    },
    getGrpList() {
      const params = {
        'page':this.page,
        'pageSize':this.pageSize,
        'projectId':localStorage.getItem("projectId")
      };
      if (this.scan_name) {
        params["name"] = this.scan_name;
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.getRoomUnionList,params,headers).then(res => {
        console.log("分组列表",res.data.data);
        this.li_grp = res.data.data["list"];
        this.total = res.data.data.total;
        if (this.li_grp) {
          this.init_View();
        } else {
          this.grp_id = 0;
          this.grp_show = "空间管理";
          this.tabData = [];
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取分组信息失败");
        }
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.getGrpList();
  },
  computed:{  /*定义计算属性-响应数据改变后重新计算*/
    fil_sonTabData() {
      return this.li_room.filter(item => {
        this.state = true;
        if (this.scan_nameSon && !item.label.includes(this.scan_nameSon)) {
          this.state = false;
        }
        return this.state;
      });
    }
  },
  watch:{  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>
#glAreaGrp {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}

.tab_adb {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}

/*.el-switch .el-switch__label--left {
  color: #FFFFFF; !* 设置左侧标签背景色 *!
}

.el-switch .el-switch__label--right {
  color: #72767b; !* 设置右侧标签背景色 *!
}*/

::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

::-webkit-scrollbar-thumb {
  border-radius: 10px; /* 滚动条圆角 */
  background-color: #0dA7C8; /* 滚动条颜色 */
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

</style>



// WEBPACK FOOTER //
// src/pages/gls/glAreaGrp.vue